<template>
  <div>
    <b-modal
      id="newpreviewFeedback"
      centered
      hide-footer
      hide-header
      no-close-on-backdrop
      size="lg"
      @hidden="closeModal()"
    >
      <div class="d-flex align-items-center p-3 w-100 justify-content-between">
        <div class="b-modal-header">Preview Feedback Form</div>
        <div @click="closeModal()">
          <img
            class="rotate-on-hover"
            src="../../assets/img/accessconnew/blueCross.svg"
            alt=""
          />
        </div>
      </div>
      <hr class="mt-0" />
      <div class="pl-3 pr-3" style="height: calc(100vh - 300px)">
        <div class="common-blue-card">
          <b-card>
            <div class="card-heading">
              Feedback form for {{ feedbackData.name }}
            </div>
          </b-card>
        </div>
        <div class="m-2 mt-4 mb-4 preview-main-container">
          <b-row class="preview-modal-container m-0">
            <b-col cols="6" class="p-0">
              <div class="w-100 d-flex align-items-center">
                <div class="head">Candidate Name :</div>
                <div class="content">[Candidate Name]</div>
              </div>
            </b-col>
            <b-col cols="6" class="p-0">
              <div class="w-100 d-flex align-items-center">
                <div class="head">Evaluation Date :</div>
                <div class="content">[DD-MM-YYYY]</div>
              </div>
            </b-col>
          </b-row>
          <b-row class="preview-modal-container mt-4 m-0">
            <b-col cols="6" class="p-0">
              <div class="w-100 d-flex align-items-center">
                <div class="head">Panel Name :</div>
                <div class="content">[Panel Name]</div>
              </div>
            </b-col>
            <b-col cols="6" class="p-0">
              <div class="w-100 d-flex align-items-center">
                <div class="head">Mode of Interview :</div>
                <div class="content">[Mode of Interview]</div>
              </div>
            </b-col>
          </b-row>

          <div
            class="mt-4 common-gray-card mr-1"
            v-for="(skill, index) in feedbackData.skillratings"
            :key="index"
          >
            <b-card>
              <div
                class="d-flex align-items-center justify-content-between w-100"
              >
                <div class="preview-modal-heading">{{ skill.name }}</div>

                <div
                  class="pff-rating d-flex align-items-center mt-2"
                  v-if="skill.markingType === 'rating'"
                >
                  <div class="newInt-inner-containers-subhead">Rating</div>
                  <b-form-rating
                    variant="primary"
                    class="scorerate newInt-rating"
                    disabled
                  ></b-form-rating>
                </div>
                <div
                  v-if="skill.markingType === 'score'"
                  class="d-flex align-items-center mt-1"
                >
                  <div class="pff-right-card-subheads">Score</div>
                  <div class="topDiv ml-1 w-30px h23px">
                    <b-form-input
                      class="modaldisableinputField w-100 h-100"
                      id="input-1"
                      type="number"
                      disabled
                    >
                    </b-form-input>
                  </div>
                  <div class="pff-right-card-subheads ml-1">out of 10</div>
                </div>
              </div>

              <div class="mt-2" v-if="skill.commentMode === true">
                <b-form-textarea
                  class="newInt-previewInputField"
                  rows="2"
                  type="text"
                  placeholder="Comments"
                  disabled
                  max-rows="5"
                >
                </b-form-textarea>
              </div>
            </b-card>
          </div>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
export default {
  name: "NewPreviewFeedback",
  props: {
    previewNewModal: Boolean,
    feedbackData: Object,
  },
  data() {
    return {};
  },
  methods: {
    closeModal() {
      this.$bvModal.hide("newpreviewFeedback");
    },
  },
};
</script>

<style>
#newpreviewFeedback .modal-body {
  padding: 0;
}

.card-heading {
  font-family: "Lato", sans-serif;
  font-style: normal;
  font-weight: 500;
  font-size: 18px;
  color: #20639b;
}

.preview-main-container {
  min-height: auto;
  max-height: calc(100vh - 395px);
  overflow-y: auto;
  overflow-x: hidden;
}

.preview-modal-container .head {
  font-family: "Montserrat";
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  color: #344054;
  width: 40%;
}

.preview-modal-container .content {
  font-family: "Lato", sans-serif;
  font-style: normal;
  font-weight: 600;
  font-size: 14px;
  color: #333333;
  width: 60%;
}

.preview-modal-heading {
  font-family: "Lato", sans-serif;
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  color: #000000;
}
</style>
